import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { GlobalSearch } from '../models/global-search';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private items: GlobalSearch[] = [];
  private filteredItems: any[] = [];

  private dataReadySub = new Subject<boolean>();
  private itemsSub = new Subject<GlobalSearch[]>();
  private itemFilteredSub = new BehaviorSubject<any[]>([]);

  ready$ = this.dataReadySub.asObservable();
  items$ = this.itemsSub.asObservable();
  filteredItems$ = this.itemFilteredSub.asObservable();

  previousKey = '';
  previousFilter = '';
  previousFields;

  constructor(
  ) {

  }

  setItems(items) {
    // when items set, search component is able to work
    this.items = items;
    this.dataReadySub.next(this.items != null);
    this.itemFilteredSub.next([]);
  }

  // add items in sub category for search
  addCatItems(items, catLabel: string, key = 'id') {
    if (!this.items) return;
    this.items = this.items.map(cat => {
      if (cat.label == catLabel) {
        cat.items = _.unionBy(items, cat.items, 'id');
      }
      return cat;
    })
  }
  removeCatItems(items, catLabel: string, key = 'id') {

  }
  updateCatItems(items, catLabel: string, key = 'id') {

  }
  refreshResult() {
    if (this.previousKey) {
      this.search(this.previousKey, this.previousFilter, this.previousFields, false);
    }
  }

  // Global search service don't care about the loading of all items
  // loadSearchItems() {
  //   // need override the search api outside for different server
  //   return this.http.get(this.endpoints.crmCommon.search, hideLoading)
  //     .pipe(
  //       map((result: { [key: string]: any[] }) => {
  //         CRMSearchCatetory.forEach(cat => cat.items = result[cat.label]);
  //         return CRMSearchCatetory;
  //       }),
  //       tap(result => {
  //         this.items = result;
  //       }));
  // }
  search(key, filter, fields, emitEvent = true) {
    this.previousKey = key;
    this.previousFilter = filter;
    this.previousFields = fields;
    if (!key) {
      this.items.forEach(cat => cat.filteredItems = null);
      this.filteredItems = null;
    }
    else {
      const lk = key.trimStart().toLowerCase();
      let filterItems = [];
      this.items.forEach(cat => {
        cat.filteredItems =
          cat.items && cat.items.filter(item => {
            if (filter == 'contains') {
              return fields.some(field => {
                const v = _.get(item, field);
                return (!cat.ignoreFields || !cat.ignoreFields.some(f => f == field)) &&
                  v && v.toLowerCase().indexOf(lk) >= 0
              });
            }
            else {
              return fields.some(field => {
                const v = _.get(item, field);
                return (!cat.ignoreFields || !cat.ignoreFields.some(f => f == field)) &&
                  v && v.toLowerCase().startsWith(lk)
              });
            }
          });
        if (cat.filteredItems && cat.filteredItems.length > 0 && cat.show) {
          filterItems = filterItems.concat(cat.filteredItems.map((item, index) => {
            return {
              index: index,
              cat: cat,
              data: item
            }
          }));
        }
      });
      this.filteredItems = filterItems;
    }
    if (emitEvent) {
      this.itemFilteredSub.next(this.filteredItems);
      this.itemsSub.next(this.items);
    }
  }
  generateFilterItems() {
    let filterItems = [];
    this.items.forEach(cat => {
      if (cat.filteredItems && cat.filteredItems.length > 0 && cat.show) {
        filterItems = filterItems.concat(cat.filteredItems.map((item, index) => {
          return {
            index: index,
            cat: cat,
            data: item
          }
        }));
      }
    });
    this.filteredItems = filterItems;
    this.itemFilteredSub.next(this.filteredItems);
  }

  publishSearchResult() {
    const result = this.items || [];
    const filteredResult = this.filteredItems || [];
    //WARNING: '__read' is imported from external module 'tslib' but never used
    //this.itemsSub.next([...(this.items || [])]);
    this.itemsSub.next(result);
    this.itemFilteredSub.next(filteredResult);
  }
}
